export interface GuiaEntrada {
  idMovimiento: number;
  numeroGuia?: string;
  idDepositoDestino?: number | null;
  transportistaDescripcion?: string;
  placaVehiculo?: string;
  choferNombre?: string;
  choferDocumento?: string;
  fechaLlegada?: string | null;
  fechaMovimiento?: string;
  estado?: string;
  observaciones?: string;
  depositoDestinoNombre?: string;
}

export const initialGuiaEntradaState: Partial<GuiaEntrada> = {
  numeroGuia: '',
  idDepositoDestino: null,
  transportistaDescripcion: '',
  placaVehiculo: '',
  choferNombre: '',
  choferDocumento: '',
  observaciones: '',
};
